/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralUserMergeRequestsRepository = (
    options: GeneralRestApiOptions
): Types.GeneralUserMergeRequestsRepository => ({
    async add(params, requestOptions) {
        return options.request('/userMergeRequests/add', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async fulfill(params, requestOptions) {
        return options.request('/userMergeRequests/fulfill', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getAll(params, requestOptions) {
        return options.request('/userMergeRequests/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async resendVerificationEmail(params, requestOptions) {
        return options.request('/userMergeRequests/resendVerificationEmail', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
